import './css/main.css'
import './css/superJackpot.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareXmark, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useMemo, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';
import { changeNum } from './common/function';

import moment from 'moment';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import './css/calendar.css'

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

let jackpotEstA = 0;

function JackpotSetting() {
    const [budgetData, setBudgetData] = useState([])
    const [data, setData] = useState([]);
    const today = new Date();
    const [date, setDate] = useState(today);
    const [activeStartDate, setActiveStartDate] = useState(new Date());
    const [rows, setRows] = useState([]); // 수정 가능한 데이터
    const [originalRows, setOriginalRows] = useState([]); // 원본 데이터
    const [changeValue, setChangeValue] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [reload, setReload] = useState(false)
    const [btn, setBtn] = useState(0)

    const [userJackpostData, setUserJackpotData] = useState([])
    const [jackpotImg, setJackpotImg] = useState([])
    const [dianModal, setDiaModal] = useState(false)
    const [budgetnModal, setBudgetModal] = useState(false)
    const [clickId, setClickId] = useState([])

    // 2025-01-24 정빈 추가
    const [budgetAmount, setBudgetAmount] = useState(0);
    const [userCount, setUserCount] = useState(0);

    let dark = useSelector((state) => { return state.Darkmode.value });
    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    useEffect(() => {
        BudgetData()
        UpgradeData();
        UserJackportData()
        JackportImgData()
    }, [reload]);

    const BudgetData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/budget', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setBudgetData(tmp?.data?.budget ?? [])
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    const UpgradeData = async () => {
        setSpinner(true);
        await axios.get(process.env.REACT_APP_API + '/api/jackpot/time')
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    setData(tmp?.data?.jackpot ?? []);
                    setSpinner(false);
                } else {
                    setSpinner(false);
                }
            }).catch((error) => {
                console.log(error);
            });
    };

    const UserJackportData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/jackpot/setting')
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    setUserJackpotData(tmp?.data?.setting ?? []);
                    setBudgetAmount(tmp?.data?.normalAmount ?? 0)
                    setUserCount(tmp?.data?.totalUser ?? 0)
                }
            }).catch((error) => {
                console.log(error);
            });
    };

    const JackportImgData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/setting/jackpot/img')
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    setJackpotImg(tmp?.data?.jackpot ?? []);
                }
            }).catch((error) => {
                console.log(error);
            });
    };

    const handleDateChange = (newDate) => {
        setDate(newDate);
    };

    const handleTodayClick = () => {
        const today = new Date();
        setActiveStartDate(today);
        setDate(today);
    };

    useEffect(() => {
        if (data) {
            let RateTime = [];
            // data.forEach((a) => {
            //     if (moment(date).format('YYYY-MM-DD') === a.jackpot_date && a?.jackpot_rate && a?.jackpot_timezone) {
            //         const timezones = a.jackpot_timezone.split("/");
            //         const rates = a.jackpot_rate.split("/");
            //         timezones.forEach((timezone, index) => {
            //             const start = `${timezone.slice(0, 2)}:${timezone.slice(2, 4)}`;
            //             const end = `${timezone.slice(4, 6)}:${timezone.slice(6, 8)}`;
            //             RateTime.push({ start, end, rate: rates[index] });
            //         });
            //     }
            // });

            // // `start` 시간을 기준으로 정렬
            // RateTime.sort((a, b) => {
            //     const timeA = moment(a.start, "HH:mm");
            //     const timeB = moment(b.start, "HH:mm");
            //     return timeA - timeB;
            // });

            data.forEach((a) => {
                const start = `${a.startTime.slice(0, 5)}`; // HH:MM 형식
                const end = `${a.endTime.slice(0, 5)}`;   // HH:MM 형식

                RateTime.push({ start, end, rate: Number(a.ratio) }); // 초 단위 제외하고 저장
            });

            setRows(RateTime); // 수정용 데이터 초기화
            setOriginalRows(RateTime); // 원본 데이터 저장
        }
    }, [data, date]);


    // 추가 버튼
    const handleAddRow = () => {
        setRows([...rows, { start: "", end: "", rate: "" }]);
    };

    // 수정 버튼
    const handleEdit = () => {
        setChangeValue(true);
    };

    // 저장 버튼
    const handleSave = async () => {
        // 유효하지 않은 행 필터링
        const validRows = rows.filter(row => row.start && row.end && row.rate);

        if (validRows.length === 0) {
            alert("저장할 유효한 데이터가 없습니다.");
            return;
        }

        // 겹치는 시간 범위 확인
        const hasOverlap = validRows.some((row, index) => {
            const startA = moment(row.start, "HH:mm");
            const endA = moment(row.end, "HH:mm");
            return validRows.some((otherRow, otherIndex) => {
                if (index === otherIndex) return false; // 자기 자신은 제외
                const startB = moment(otherRow.start, "HH:mm");
                const endB = moment(otherRow.end, "HH:mm");
                // 시간 범위가 겹치는지 확인
                return startA.isBefore(endB) && endA.isAfter(startB);
            });
        });

        if (hasOverlap) {
            alert("시간 범위가 겹치는 항목이 있습니다. 수정 후 다시 시도하세요.");
            return;
        }

        const slots = validRows.map(row => ({
            start_time: row.start,
            end_time: row.end,
            ratio: Number(row.rate || 0), // rate를 숫자로 변환하여 저장
        }));

        // API 요청
        await axios.post(process.env.REACT_APP_API + '/api/jackpot/time', {
            slots: slots
        }).then((response) => {
            let tmp = response.data;
            if (tmp?.code === 1000) {
                console.log("저장 성공");
                setReload(e => !e);
            }
            setChangeValue(false);
        }).catch((error) => {
            console.log(error);
        });
    };


    // 취소 버튼
    const handleCancel = () => {
        setRows(originalRows); // 원본 데이터로 복원
        setChangeValue(false); // 수정 모드 종료
    };

    // 삭제 버튼
    const handleDeleteRow = (index) => {
        setRows((prevRows) => prevRows.filter((_, i) => i !== index));
    };

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const [formData, setFormData] = useState({
        rate: "", // 리디렉션 URL
        file: '', // 업로드된 파일
    });

    const [imagePreviews, setImagePreviews] = useState([]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'checkbox') {
            setFormData({ ...formData, [name]: checked });
        } else if (type === 'file') {
            setFormData({ ...formData, file: files });
            handleImagePreview(files);
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // 이미지 미리보기 처리 함수
    const handleImagePreview = (files) => {
        const previewArray = Array.from(files).map((file) => {
            const reader = new FileReader();
            return new Promise((resolve) => {
                reader.onloadend = () => {
                    resolve(reader.result); // 파일의 base64 데이터를 resolve
                };
                reader.readAsDataURL(file); // 파일을 base64로 변환
            });
        });

        Promise.all(previewArray).then((images) => {
            setImagePreviews(images); // 미리보기 이미지들을 저장
        });
    };

    const onSubmit = async () => {
        const formDataObj = new FormData();

        formDataObj.append('rate', formData.rate);
        if (formData.file.length > 0) {
            formDataObj.append("file", formData.file[0]);
        } else {
            alert("이미지를 선택하세요.");
            return;
        }

        await axios.post(process.env.REACT_APP_API + "/api/setting/jackpot/img-regist", formDataObj, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setFormData({
                    rate: "", // 리디렉션 URL
                    file: '', // 업로드된 파일
                })
                setImagePreviews([])
                setReload(e => !e)
            }
            else {
                // setMessage({ msg: "등록에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }


    const [inputValues, setInputValues] = useState([]);

    useEffect(() => {
        if (userJackpostData?.length) {
            setInputValues(userJackpostData.map((item) => ({ id: item.id, value: item.value })));
        }
    }, [userJackpostData]);

    const handleJackpotInputChange = (id, value) => {
        setInputValues((prev) =>
            prev.map((item) => (item.id === id ? { ...item, value } : item))
        );
    };

    const onSubmitUpdate = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/jackpot/setting/update', {
            settings: inputValues
        }, {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };




    const [message, setMessage] = useState({ code: -1, msg: "" })
    const [superPage, setSuperPage] = useState(1)


    const [superList, setSuperList] = useState([])
    const [superListSelect, setSuperListSelect] = useState([])
    const [superTicketList, setSuperTicketList] = useState([])
    const [superHistoryList, setSuperHistoryList] = useState([])

    const [superReload, setSuperReload] = useState(false)
    const [superSelectId, setSuperSelectId] = useState("")
    
    const [superJackpotImageUrl, setSuperJackpotImageUrl] = useState(""); // 인풋 표시용(읽기 전용)
    const [superJackpotFile, setSuperJackpotFile] = useState(null);        // 새로 선택한 파일
    const [superJackpotPreview, setSuperJackpotPreview] = useState("");    // 화면에 실제로 보이는 미리보기
    const [superJackpotOriginalUrl, setSuperJackpotOriginalUrl] = useState(""); // 서버 등록(원본) 이미지 URL
    const [superJackpotLocalPreview, setSuperJackpotLocalPreview] = useState(false); // 로컬 파일 미리보기 중인지
    const [superJackpotPrevBlobUrl, setSuperJackpotPrevBlobUrl] = useState("");     // blob URL revoke용
    const superJackpotFileInputRef = useRef(null);

    useEffect(() => {
        SuperList()
        SuperTicketList()
        SuperHistoryData()
    }, [superReload])

    useEffect(() => {
        SuperTicketData(superSelectId)
    }, [superReload, superSelectId])

    const SuperList = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/super-jackpot')
            .then((response) => {
                let tmp = response.data;
                // console.log(tmp)
                if (tmp?.code < 2000) {
                    setSuperList(tmp?.data?.master ?? []);
                }
            }).catch((error) => {
                console.log(error);
            });
    };

    const SuperTicketList = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/super-jackpot/simple-list')
            .then((response) => {
                let tmp = response.data;
                console.log(tmp)
                if (tmp?.code < 2000) {
                    setSuperListSelect(tmp?.data?.superjackpot ?? []);
                }
            }).catch((error) => {
                console.log(error);
            });
    };

    const SuperTicketData = async (id) => {
        await axios.get(process.env.REACT_APP_API + '/api/super-jackpot/ticket', {
            params: {
                sjmId: id
            }
        }).then((response) => {
            let tmp = response.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setSuperTicketList(tmp?.data?.ticket ?? []);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const SuperHistoryData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/super-jackpot/result', {
        }).then((response) => {
            let tmp = response.data;
            // console.log(tmp)
            if (tmp?.code < 2000) {
                setSuperHistoryList(tmp?.data?.master ?? []);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const alignTo30 = (d) => {
        const x = new Date(d);
        x.setSeconds(0, 0);
        const m = x.getMinutes();
        const add = m % 30 === 0 ? 0 : 30 - (m % 30);
        x.setMinutes(m + add);
        return x;
    };

    const [superListFormData, setSuperListFormData] = useState({
        sjmName: "",
        sjmStartTime: new Date(),
        sjmEndTime: (() => {
            const d = new Date();
            d.setDate(d.getDate() + 7);
            return d;
        })(),
        sjmWinRate: "",
        sjmUnitCount: "",
    });

    // ---------------------------
    // 공통 change handler
    // ---------------------------
    const handleSuperListChange = (field, value) => {
        setSuperListFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    // ---------------------------
    // 유효성 검사
    // ---------------------------
    const isDateOrderValid = useMemo(
        () => superListFormData.sjmStartTime <= superListFormData.sjmEndTime,
        [superListFormData.sjmStartTime, superListFormData.sjmEndTime]
    );

    const parsedWinRate = useMemo(() => {
        const v = Number(superListFormData.sjmWinRate);
        return Number.isFinite(v) ? v : NaN;
    }, [superListFormData.sjmWinRate]);

    const parsedUnitCount = useMemo(() => {
        const v = Number(superListFormData.sjmUnitCount);
        return Number.isInteger(v) ? v : NaN;
    }, [superListFormData.sjmUnitCount]);

    const isFormValid = useMemo(() => {
        if (!superListFormData.sjmName.trim()) return false;
        if (!isDateOrderValid) return false;
        if (!Number.isFinite(parsedWinRate) || parsedWinRate < 0 || parsedWinRate > 100) return false;
        if (!Number.isInteger(parsedUnitCount) || parsedUnitCount < 0) return false;
        return true;
    }, [superListFormData, isDateOrderValid, parsedWinRate, parsedUnitCount]);

    // ---------------------------
    // 날짜 포맷
    // ---------------------------
    const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
    const formatDateTime = (d) => {
        if (!(d instanceof Date)) return "";
        const yyyy = d.getFullYear();
        const MM = pad(d.getMonth() + 1);
        const dd = pad(d.getDate());
        const HH = pad(d.getHours());
        const mm = pad(d.getMinutes());
        return `${yyyy}-${MM}-${dd} ${HH}:${mm}:00`;
    };

    // ---------------------------
    // 추가 버튼 핸들러
    // ---------------------------
    const onSubmitSuperAdd = async () => {
        if (!isFormValid) {
            alert("입력값을 다시 확인해주세요.");
            return;
        }

        const payload = {
            sjmName: superListFormData.sjmName.trim(),
            sjmStartTime: formatDateTime(superListFormData.sjmStartTime),
            sjmEndTime: formatDateTime(superListFormData.sjmEndTime),
            sjmWinRate: String(parsedWinRate),
            sjmUnitCount: String(parsedUnitCount),
        };

        try {
            const res = await axios.post(process.env.REACT_APP_API + "/api/super-jackpot", payload);
            if (res.data?.code === 1000) {
                console.log("저장 성공");
                setSuperListFormData({
                    sjmName: "",
                    sjmStartTime: new Date(),
                    sjmEndTime: (() => {
                        const d = new Date();
                        d.setDate(d.getDate() + 7);
                        return d;
                    })(),
                    sjmWinRate: "",
                    sjmUnitCount: "",
                })
                setSuperReload((e) => !e);
            } else {
            }
        } catch (err) {
            console.error(err);
        } finally {
            setChangeValue?.(false);
        }
    };

    const [text, setText] = useState("");                   // sjName
    const [qty, setQty] = useState("");                     // count

    // 최초 로딩 또는 옵션 변경 시 기본 선택이 없으면 최소 id로 선택
    useEffect(() => {
        if (!superSelectId && Array.isArray(superListSelect) && superListSelect.length > 0) {
            console.log(superListSelect)
            setSuperSelectId(String(superListSelect[0].sjm_id));
        }
    }, [superSelectId, superListSelect]);

    // 유효성
    const qtyNum = Number(qty);
    const isValid =
        !!superSelectId && Number.isFinite(qtyNum) && qtyNum >= 0;

    // 추가 버튼
    const onSubmitSuperTicketAdd = async () => {
        if (!isValid) return;

        const payload = {
            sjmId: Number(superSelectId),
            sjName: text,
            count: String(qtyNum),
        };

        try {
            const res = await axios.post(
                process.env.REACT_APP_API + "/api/super-jackpot/ticket",
                payload
            );
            if (res.data?.code === 1000) {
                console.log("저장 성공");
                setSuperReload?.((e) => !e);
                // 입력값 초기화 (원하면 유지)
                setText("");
                setQty("");
            }
        } catch (err) {
            console.error(err);
        } finally {
            setChangeValue?.(false);
        }
    };

    const onSubmitSuperTicketComplete = async () => {
        const payload = {
            sjmId: Number(superSelectId),
        };

        try {
            const res = await axios.post(
                process.env.REACT_APP_API + "/api/super-jackpot/start",
                payload
            );
            if (res.data?.code === 1000) {
                console.log("저장 성공");
                setSuperSelectId("")
                setSuperListSelect([])
                setSuperTicketList([])
                setSuperJackpotImageUrl(null);
                setSuperJackpotPreview(null);
                setSuperJackpotFile(null);
                setSuperReload((e) => !e);
                setText("");
                setQty("");
            }
        } catch (err) {
            console.error(err);
        } finally {
            setChangeValue?.(false);
        }
    };

    const excelSample = () => {
        let arr = [];

        arr.push({
            "name": "",
            "quantity": "",
        })

        ExcelSample(arr)
    }

    const fileRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    // 버튼 클릭 시 파일 선택창 열기
    const openPicker = () => fileRef.current?.click();

    // 파일 선택되면 곧바로 업로드
    const onChangeAndUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // (선택) 간단 검증
        if (!/\.(xlsx|xls|csv)$/i.test(file.name)) {
            alert("엑셀(xlsx/xls) 또는 CSV 파일만 업로드 가능합니다.");
            e.target.value = "";
            return;
        }

        const form = new FormData();
        form.append("file", file);
        form.append("sjmId", superSelectId);

        try {
            setUploading(true);

            const res = await axios.post(
                `${process.env.REACT_APP_API}/api/super-jackpot/ticket/upload`,
                form,
                {
                    // axios가 boundary 포함 Content-Type 자동 설정하므로 수동 지정 불필요
                    timeout: 60_000,
                    onUploadProgress: (evt) => {
                        // 필요 시 진행률 표시 가능 (예: setProgress)
                        // if (evt.total) setProgress(Math.round((evt.loaded*100)/evt.total));
                    },
                }
            );

            if (res.data?.code === 1000) {
            } else {
                alert(res.data?.msg || "업로드 처리 중 오류가 발생했습니다.");
            }
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.msg || "네트워크/서버 오류가 발생했습니다.");
        } finally {
            setUploading(false);
            // 같은 파일 재선택 가능하도록 리셋
            e.target.value = "";
        }
    };


    // 선택(또는 목록) 변경 시: 원본 주소를 세팅하고, 로컬 미리보기 중이 아니라면 화면에도 반영
    useEffect(() => {
        const path =
            (superListSelect ?? []).find((item) => item.sjm_id == superSelectId)?.image_path ?? "";

        setSuperJackpotOriginalUrl(path);

        if (!superJackpotLocalPreview) {
            setSuperJackpotImageUrl(path);
            setSuperJackpotPreview(path);
            setSuperJackpotFile(null);
        }
    }, [superSelectId, superListSelect, superJackpotLocalPreview]);

    // 편의 플래그
    const superJackpotRegistered = !!superJackpotOriginalUrl; // 서버에 등록된(원본) 이미지 존재 여부
    const superJackpotEditing = !!superJackpotLocalPreview;   // 새 파일 업로드로 수정 중인지(미리보기 교체 중)
    const superJackpotHasImage = !!(superJackpotPreview && superJackpotPreview.length > 0);

    // 숨겨진 파일 인풋 열기
    const onClickChooseFile = () => {
        if (superJackpotFileInputRef.current) {
            superJackpotFileInputRef.current.value = ""; // 같은 파일 재선택 허용
            superJackpotFileInputRef.current.click();
        }
    };

    // 파일 선택
    const onChangeSuperJackpotFile = (e) => {
        const f = e.target.files?.[0];
        if (!f) return;

        if (superJackpotPrevBlobUrl) {
            URL.revokeObjectURL(superJackpotPrevBlobUrl);
            setSuperJackpotPrevBlobUrl("");
        }

        const blobUrl = URL.createObjectURL(f);
        setSuperJackpotFile(f);
        setSuperJackpotPreview(blobUrl);
        setSuperJackpotImageUrl(blobUrl);
        setSuperJackpotPrevBlobUrl(blobUrl);
        setSuperJackpotLocalPreview(true); // 이제 "수정/취소" 또는 "등록/취소" 상태로 전환
    };

    // 업로드/수정 (엔드포인트 동일하게 사용)
    const onSubmitSuperJackpotUploadOrUpdate = async () => {
        if (!superSelectId) return alert("대상이 선택되지 않았습니다.");
        if (!superJackpotFile) return alert("이미지 파일을 선택해주세요.");

        const form = new FormData();
        form.append("sjmId", superSelectId);
        form.append("image", superJackpotFile);

        const isUpdate = superJackpotRegistered;
        const endpoint = "/api/super-jackpot-image";

        try {
            const res = await axios.post(process.env.REACT_APP_API + endpoint, form, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            if (res.data?.code === 1000) {
                setSuperJackpotLocalPreview(false);
                setSuperReload((e) => !e);
            } else {
                alert(res.data?.msg || "요청 처리 실패");
            }
        } catch (err) {
            console.error(err);
            alert("업로드/수정 중 오류 발생");
        }
    };

    // 삭제(초기화)
    const onClickSuperJackpotDelete = async () => {
        if (!superSelectId) return alert("대상이 선택되지 않았습니다.");
        if (!window.confirm("이미지를 삭제(초기화)하시겠습니까?")) return;

        try {
            const res = await axios.post(
                process.env.REACT_APP_API + "/api/super-jackpot-image/delete",
                { sjmId: superSelectId }
            );

            if (res.data?.code === 1000) {
                if (superJackpotPrevBlobUrl) URL.revokeObjectURL(superJackpotPrevBlobUrl);

                // 원본 자체가 삭제되므로 전부 초기화
                setSuperJackpotOriginalUrl("");
                setSuperJackpotImageUrl("");
                setSuperJackpotPreview("");
                setSuperJackpotFile(null);
                setSuperJackpotPrevBlobUrl("");
                setSuperJackpotLocalPreview(false);
                setSuperReload((e) => !e);
            } else {
                alert(res.data?.msg || "삭제 실패");
            }
        } catch (err) {
            console.error(err);
            alert("삭제 중 오류 발생");
        }
    };

    // 취소(로컬 미리보기 → 원본 복원)
    const onClickSuperJackpotCancel = () => {
        if (superJackpotPrevBlobUrl) {
            URL.revokeObjectURL(superJackpotPrevBlobUrl);
            setSuperJackpotPrevBlobUrl("");
        }
        setSuperJackpotFile(null);
        setSuperJackpotLocalPreview(false);
        setSuperJackpotImageUrl(superJackpotOriginalUrl);
        setSuperJackpotPreview(superJackpotOriginalUrl);
    };

    return (
        <div className='main'>
            <Message message={message} />

            {dianModal && (<DiaModal dark={dark} darkname={darkname} setDiaModal={setDiaModal} clickId={clickId} setReload={setReload} />)}
            {budgetnModal && (<BudgetUpdate darkname={darkname} setBudgetModal={setBudgetModal} clickId={clickId} setReload={setReload} />)}

            <div className='maintab' style={{ marginBottom: "20px" }}>
                <div className={btn === 0 ? `maintab-1 on ${darkname}` : `maintab-1 ${darkname}`} onClick={() => { setBtn(0) }}>버짓설정</div>
                <div className={btn === 2 ? `maintab-1 on ${darkname}` : `maintab-1 ${darkname}`} onClick={() => { setBtn(2) }}>잭팟설정</div>
                <div className={btn === 1 ? `maintab-1 on ${darkname}` : `maintab-1 ${darkname}`} onClick={() => { setBtn(1) }}>잭팟이미지</div>
                <div className={btn === 3 ? `maintab-1 on ${darkname}` : `maintab-1 ${darkname}`} onClick={() => { setBtn(3) }}>슈퍼잭팟등록</div>
                <div className={btn === 4 ? `maintab-1 on ${darkname}` : `maintab-1 ${darkname}`} onClick={() => { setBtn(4) }}>슈퍼잭팟관리</div>
                <div className={btn === 5 ? `maintab-1 on ${darkname}` : `maintab-1 ${darkname}`} onClick={() => { setBtn(5) }}>슈퍼잭팟내역</div>
            </div>
            <div className={`main-box-1 ${darkname}`}>
                {
                    btn === 0
                        ?
                        <>
                            <div>
                                <div className={`StyledCalendarWrapper ${darkname}`} style={{ width: "1000px" }}>
                                    <Calendar
                                        value={date}
                                        onChange={handleDateChange}
                                        formatDay={(locale, date) => moment(date).format('D')}
                                        formatYear={(locale, date) => moment(date).format('YYYY')}
                                        formatMonthYear={(locale, date) => moment(date).format('YYYY. MM')}
                                        calendarType="gregory"
                                        showNeighboringMonth={false}
                                        next2Label={null}
                                        prev2Label={null}
                                        minDetail="year"
                                        activeStartDate={activeStartDate === null ? undefined : activeStartDate}
                                        onActiveStartDateChange={({ activeStartDate }) =>
                                            setActiveStartDate(activeStartDate)
                                        }
                                        tileDisabled={({ date, view }) => {
                                            if (view === "month") {
                                                // 오늘 이전 날짜는 비활성화
                                                return moment(date).isBefore(moment(), 'day');
                                            }
                                            return false;
                                        }}
                                        tileContent={({ date, view }) => {
                                            if (view === "month") {
                                                const tmp = budgetData.find(
                                                    (item) => item.budget_date === moment(date).format("YYYY-MM-DD")
                                                );

                                                if (tmp) {
                                                    return (
                                                        <div
                                                            key={`${tmp.budget_date}`} // 고유한 key 값 생성
                                                            className={`StyledEX ${moment(date).isBefore(moment(), 'day') ? 'disabled' : ''}`}
                                                            style={{
                                                                pointerEvents: moment(date).isBefore(moment(), 'day') ? "none" : "auto",
                                                                opacity: moment(date).isBefore(moment(), 'day') ? 0.5 : 1,
                                                            }}
                                                            onClick={() => {
                                                                if (!moment(date).isBefore(moment(), 'day')) {
                                                                    setClickId(tmp);
                                                                    setBudgetModal(true);
                                                                }
                                                            }}
                                                        >
                                                            <div className="StyledEX-1">
                                                                <div>전체:</div>
                                                                <div>{changeNum(tmp.total_budget)}</div>
                                                            </div>
                                                            <div className="StyledEX-2">
                                                                <div>잭팟:</div>
                                                                <div>
                                                                    {changeNum(tmp.spent_amount)} / {changeNum(tmp.awarded_count)}건
                                                                </div>
                                                            </div>
                                                            <div className="StyledEX-3">
                                                                <div>잔액:</div>
                                                                <div>{changeNum(tmp.remaining_amount)}</div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            }
                                            return null;
                                        }}
                                    />

                                    <div className='StyledDate' onClick={handleTodayClick}>Today</div>
                                </div>
                            </div>
                            <div className={`member-2 ${darkname}`} style={{ width: "400px" }}>
                                <div className='gameSetting-btn-1' style={{ marginBottom: "20px" }}>
                                    {changeValue ? (
                                        <>
                                            <div className='gameSetting-btn-2' onClick={handleCancel}>취소</div>
                                            <div className='gameSetting-btn-2' onClick={handleAddRow}>추가</div>
                                            <div className='gameSetting-btn-2' onClick={handleSave}>저장</div>
                                        </>
                                    ) : (
                                        <div className='gameSetting-btn-2' onClick={handleEdit}>수정</div>
                                    )}
                                </div>
                                <div className='gameSetting-btn-1' style={{ marginBottom: "10px" }}>
                                    <div className='gameSetting-btn-text' style={{ width: "310px", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <div>* 총 비율:</div>
                                        {/* <div>{Math.max(...rows.map(row => Number(row.rate || 0)))??100}%</div> */}
                                        <div>100%</div>
                                    </div>
                                </div>

                                <div className={`table-head ${darkname}`}>
                                    <div>시작시간</div>
                                    <div>종료시간</div>
                                    <div>비율</div>
                                    <div style={{ width: "10%", minWidth: "50px" }}></div>
                                </div>
                                <div className='table-body' style={{ minHeight: "600px" }}>
                                    {spinner ? (
                                        <div className='spinner-modal'>
                                            <SyncLoader color="#003577" />
                                        </div>
                                    ) : rows.length === 0 ? (
                                        <div className='data-nofound'>
                                            <img src='/img/img_nofound.png' alt="No records found" />
                                            <p>NO RECORDS FOUND</p>
                                        </div>
                                    ) : (
                                        rows.map((row, index) => (
                                            <div key={index} className={`table-body-tr ${darkname}`}>
                                                <div className='td'>
                                                    {changeValue ? (
                                                        <input
                                                            type="text"
                                                            value={row.start}
                                                            onChange={(e) => handleInputChange(index, "start", e.target.value)}
                                                        />
                                                    ) : (
                                                        row.start
                                                    )}
                                                </div>
                                                <div className='td'>
                                                    {changeValue ? (
                                                        <input
                                                            type="text"
                                                            value={row.end}
                                                            onChange={(e) => handleInputChange(index, "end", e.target.value)}
                                                        />
                                                    ) : (
                                                        row.end
                                                    )}
                                                </div>
                                                <div className='td'>
                                                    {changeValue ? (
                                                        <input
                                                            type="text"
                                                            value={row.rate}
                                                            onChange={(e) => handleInputChange(index, "rate", e.target.value)}
                                                        />
                                                    ) : (
                                                        row.rate
                                                    )}
                                                </div>
                                                <div className='td' style={{ width: "10%", minWidth: "50px" }}>
                                                    {changeValue && (
                                                        <FontAwesomeIcon icon={faSquareXmark} onClick={() => handleDeleteRow(index)} style={{ fontSize: "22px", color: 'gray', cursor: 'pointer' }} />
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </>
                        :
                        btn === 1
                            ?
                            <div style={{ width: "100%" }}>
                                <div className='budget-box' style={{ marginBottom: "20px" }}>
                                    <div style={{ marginBottom: "20px", fontSize: "18px", fontWeight: "bold" }}>이미지 등록</div>
                                    <div className='create-img-box'>
                                        <div className=''>
                                            <div className='budget-2'>
                                                <div className='budget-1-3'>이미지 첨부</div>
                                                <div className='budget-1-2'>
                                                    <label htmlFor="file" className="form-control file_form" style={{ display: "block" }}>
                                                        {formData.file ? Array.from(formData.file).map(file => file.name).join(', ') : "파일선택"}
                                                    </label>
                                                    <input type="file" id="file" name="file" style={{ display: "none" }} multiple accept="image/*" onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className='budget-2'>
                                                <div className='budget-1-3'>잭팟 최소 금액</div>
                                                <div className='budget-1-2'>
                                                    <input className='file-input' style={{ width: "300px" }} type="text" name="rate" placeholder="최소 금액" value={formData.rate || ""} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className='ads-btn' onClick={() => onSubmit()}>등록</div>
                                        </div>
                                        <div className='ads-preImg'>
                                            <div>미리보기</div>
                                            {
                                                imagePreviews.length > 0 &&
                                                imagePreviews.map((src, index) => (
                                                    <img key={index} src={src} alt={`preview ${index}`} className="multipreview" style={{ height: "200px" }} />
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={`main-box ${darkname}`}>
                                    <div style={{ textAlign: "left", paddingLeft: "20px", lineHeight: "24px" }}>
                                        <FontAwesomeIcon icon={faArrowRight} /> 잭팟 이미지는 설정된 잭팟 다이아가 속한 구간의 이미지가 노출 됩니다.<br />
                                        <FontAwesomeIcon icon={faArrowRight} /> 첫번째 구간(0~)은 최소 금액을 수정할 수 없고, 이미지만 수정 가능하니다.<br />

                                        {/* 구간 이미지를 등록하지 않거나, 구간이 없을 경우 기본 이미지(보라괴물)가 노출 됩니다.<br />
                                        Ex) 하늘괴물이 200, 초록괴물이 400 으로 등록되어 있을 때,<br />
                                        <span style={{ paddingLeft: "25px" }}>잭팟 다이아 500 <FontAwesomeIcon icon={faArrowRight} /> 초록괴물 노출</span><br />
                                        <span style={{ paddingLeft: "25px" }}>잭팟 다이아 300 <FontAwesomeIcon icon={faArrowRight} /> 하늘괴물 노출</span><br />
                                        <span style={{ paddingLeft: "25px" }}>잭팟 다이아 100 <FontAwesomeIcon icon={faArrowRight} /> 보라괴물 노출</span><br /> */}
                                    </div>
                                    <div className={`member-2 ${darkname}`} style={{ marginTop: "50px", width: "1000px" }}>
                                        <div className={`table-head ${darkname}`}>
                                            <div style={{ width: "15%", minWidth: "150px" }}>잭팟 다이아 구간</div>
                                            <div style={{ width: "50%", minWidth: "200px" }}>이미지 미리보기</div>
                                            <div style={{ width: "10%", minWidth: "200px" }}>가로(추천: 200px)</div>
                                            <div style={{ width: "10%", minWidth: "200px" }}>세로</div>
                                            <div style={{ width: "15%", minWidth: "150px" }}></div>
                                        </div>
                                        <div className='table-body' style={{ minHeight: "600px" }}>
                                            {
                                                spinner
                                                    ?
                                                    <div className='spinner-modal'>
                                                        <SyncLoader color="#003577" />
                                                    </div>
                                                    :
                                                    jackpotImg.length === 0
                                                        ?
                                                        <div className='data-nofound'>
                                                            <img src='/img/img_nofound.png'></img>
                                                            <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                                            <p>NO RECORDS FOUND</p>
                                                        </div>
                                                        :
                                                        <>
                                                            {
                                                                jackpotImg.map(function (a, i) {
                                                                    const nextValue = i < jackpotImg.length - 1 ? jackpotImg[i + 1] : null;
                                                                    return (
                                                                        <JackpotImgList key={i} item={a} darkname={darkname} dark={dark} setReload={setReload} newBudget={nextValue} />
                                                                    )
                                                                })
                                                            }
                                                        </>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            btn === 2
                                ?
                                <div className={`member-2 ${darkname}`} style={{ width: "800px" }}>
                                    <div className={`table-head ${darkname}`}>
                                        <div style={{ width: "1%", minWidth: "50px" }}>no.</div>
                                        <div style={{ width: "15%", minWidth: "150px" }}>밸류</div>
                                        <div style={{ width: "20%", minWidth: "250px" }}>형식</div>
                                        <div style={{ width: "49%", minWidth: "350px" }}>설명</div>
                                    </div>
                                    <div className="table-body" style={{ minHeight: "260px" }}>
                                        {spinner ? (
                                            <div className="spinner-modal">
                                                <SyncLoader color="#003577" />
                                            </div>
                                        ) : userJackpostData.length === 0 ? (
                                            <div className="data-nofound">
                                                <img src="/img/img_nofound.png" alt="No data found" />
                                                <p>NO RECORDS FOUND</p>
                                            </div>
                                        ) : (
                                            <>
                                                {userJackpostData.map((a, i) => (
                                                    <MemberItem
                                                        key={i}
                                                        item={a}
                                                        seq={i + 1}
                                                        darkname={darkname}
                                                        dark={dark}
                                                        handleJackpotInputChange={handleJackpotInputChange}
                                                        budgetAmount={budgetAmount}
                                                        userCount={userCount}
                                                    />
                                                ))}
                                            </>
                                        )}
                                    </div>
                                    <div className="gameSetting-btn-1">
                                        <div className="gameSetting-btn-2" onClick={() => onSubmitUpdate()}>저장</div>
                                    </div>
                                </div>
                                :
                                btn === 3
                                    ?
                                    <div style={{ width: "100%" }}>
                                        <div className="budget-box" style={{ marginBottom: 20 }}>
                                            <div style={{ marginBottom: 10, fontSize: 18, fontWeight: "bold" }}>슈퍼잭팟 기간 등록 <span style={{ fontSize: 14, color: "red", marginLeft: "6px" }}>* 복권 등 사행성으로 슈퍼잭팟을 사용할 경우 관련 법에 저촉될 수 있습니다</span></div>

                                            <div className="superJackpot-container superJackpot">
                                                <div className="superJackpot-header-grid">
                                                    <div className="superJackpot-col-4">
                                                        <label className="superJackpot-form-label">회차</label>
                                                        <input
                                                            className="superJackpot-form-control"
                                                            value={superListFormData.sjmName}
                                                            onChange={(e) => handleSuperListChange("sjmName", e.target.value)}
                                                            placeholder="예) 202532"
                                                            style={{ width: 140 }}
                                                        />
                                                    </div>

                                                    <div className="superJackpot-col-4">
                                                        <label className="superJackpot-form-label">시작일</label>
                                                        <div className="superJackpot-form-control"
                                                            style={{ width: 140, padding: "0" }}>
                                                            <DatePicker
                                                                selected={superListFormData.sjmStartTime}
                                                                onChange={(date) => handleSuperListChange("sjmStartTime", date)}
                                                                dateFormat="yyyy-MM-dd HH:mm"
                                                                showTimeSelect
                                                                timeFormat="HH:mm"
                                                                timeIntervals={30}
                                                                placeholderText="시작일/시간 선택"
                                                                shouldCloseOnSelect
                                                                maxDate={superListFormData.sjmEndTime}
                                                                style={{ width: "auto", padding: "0" }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="superJackpot-col-4">
                                                        <label className="superJackpot-form-label">마감일</label>
                                                        <div className="superJackpot-form-control"
                                                            style={{ width: 140, padding: "0" }}>
                                                            <DatePicker
                                                                selected={superListFormData.sjmEndTime}
                                                                onChange={(date) => handleSuperListChange("sjmEndTime", date)}
                                                                dateFormat="yyyy-MM-dd HH:mm"
                                                                showTimeSelect
                                                                timeFormat="HH:mm"
                                                                timeIntervals={30}
                                                                placeholderText="종료일/시간 선택"
                                                                shouldCloseOnSelect
                                                                minDate={superListFormData.sjmStartTime}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="superJackpot-col-4">
                                                        <label className="superJackpot-form-label">당첨확률(%)</label>
                                                        <input
                                                            className="superJackpot-form-control"
                                                            type="number"
                                                            min={0}
                                                            max={100}
                                                            step="0.01"
                                                            value={superListFormData.sjmWinRate}
                                                            onChange={(e) => handleSuperListChange("sjmWinRate", e.target.value)}
                                                            style={{ width: 100, textAlign: "right" }}
                                                        />
                                                    </div>

                                                    <div className="superJackpot-col-4">
                                                        <label className="superJackpot-form-label">최대중복당첨</label>
                                                        <input
                                                            className="superJackpot-form-control"
                                                            type="number"
                                                            min={0}
                                                            step="1"
                                                            value={superListFormData.sjmUnitCount}
                                                            onChange={(e) => handleSuperListChange("sjmUnitCount", e.target.value)}
                                                            style={{ width: 100, textAlign: "right" }}
                                                        />
                                                    </div>
                                                    <div className="superJackpot-col-3">
                                                        <button className="superJackpot-btn" onClick={onSubmitSuperAdd}>
                                                            추가
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`main-box ${darkname}`}>
                                            <div className={`member-2 ${darkname}`} style={{ marginTop: "50px", width: "900px" }}>
                                                <div className={`table-head ${darkname}`}>
                                                    <div style={{ width: "5%", minWidth: "50px" }}>No.</div>
                                                    <div style={{ width: "20%", minWidth: "150px" }}>회차</div>
                                                    <div style={{ width: "20%", minWidth: "150px" }}>시작일</div>
                                                    <div style={{ width: "20%", minWidth: "150px" }}>마감일</div>
                                                    <div style={{ width: "10%", minWidth: "120px" }}>당첨확률</div>
                                                    <div style={{ width: "10%", minWidth: "120px" }}>최대중복당첨</div>
                                                    <div style={{ width: "20%", minWidth: "150px" }}></div>
                                                </div>
                                                <div className='table-body' style={{ minHeight: "600px" }}>
                                                    {
                                                        spinner
                                                            ?
                                                            <div className='spinner-modal'>
                                                                <SyncLoader color="#003577" />
                                                            </div>
                                                            :
                                                            superList.length === 0
                                                                ?
                                                                <div className='data-nofound'>
                                                                    <img src='/img/img_nofound.png'></img>
                                                                    <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                                                    <p>NO RECORDS FOUND</p>
                                                                </div>
                                                                :
                                                                <>
                                                                    {
                                                                        superList.map(function (a, i) {
                                                                            return (
                                                                                <SuperJackpotList key={i} item={a} darkname={darkname} setSuperReload={setSuperReload} />
                                                                            )
                                                                        })
                                                                    }
                                                                </>

                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    btn === 4
                                        ?
                                        <div style={{ width: "100%" }}>
                                            <div className="budget-box" style={{ marginBottom: 20 }}>
                                                <div style={{ marginBottom: 10, fontSize: 18, fontWeight: "bold" }}>슈퍼잭팟관리</div>

                                                <div className="superJackpot-container">
                                                    <div className="superJackpot-header-grid">
                                                        <div className="superJackpot-col-3">
                                                            <label className="superJackpot-form-label">회차</label>
                                                            <select
                                                                className="superJackpot-form-control"
                                                                value={superSelectId}
                                                                onChange={(e) => setSuperSelectId(e.target.value)}
                                                                style={{ width: 150 }}
                                                            >
                                                                {superListSelect.map((opt) => (
                                                                    <option key={opt.sjm_id} value={opt.sjm_id}>
                                                                        {opt.sjm_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="superJackpot-input-grid">
                                                        <div className="superJackpot-col-7">
                                                            <label className="superJackpot-form-label">이미지</label>

                                                            {/* 레이아웃: [파일선택 버튼] [미리보기 박스] [버튼그룹] */}
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    gap: "8px",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                {/* 1) 파일 선택 버튼 */}
                                                                <div>
                                                                    <button
                                                                        type="button"
                                                                        className="superJackpot-btn"
                                                                        onClick={onClickChooseFile}
                                                                        style={{ width: "80px" }}
                                                                    >
                                                                        파일선택
                                                                    </button>

                                                                    {/* 숨겨진 파일 인풋 */}
                                                                    <input
                                                                        type="file"
                                                                        accept="image/*"
                                                                        ref={superJackpotFileInputRef}
                                                                        style={{ display: "none" }}
                                                                        onChange={onChangeSuperJackpotFile}
                                                                    />
                                                                </div>

                                                                {/* 2) 미리보기(없어도 자리 고정) */}
                                                                <div
                                                                    style={{
                                                                        width: 250,
                                                                        height: 32,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        background: "#fafafa",
                                                                        overflow: "hidden",
                                                                        position: "relative",
                                                                    }}
                                                                    title={superJackpotImageUrl || ""}
                                                                >
                                                                    {superJackpotHasImage ? (
                                                                        <>
                                                                            <img
                                                                                src={superJackpotPreview}
                                                                                alt="미리보기"
                                                                                style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                                                                                onError={(e) => {
                                                                                    e.currentTarget.style.display = "none";
                                                                                    console.warn("미리보기 로드 실패:", superJackpotPreview);
                                                                                }}
                                                                            />
                                                                            <div style={{
                                                                                position: "absolute",
                                                                                top: "50%",
                                                                                transform: "translateY(-50%)",
                                                                                fontSize: "13px",
                                                                                fontFamily: "'Roboto Mono', monospace",
                                                                                fontSize: 13,
                                                                                fontWeight: 600,
                                                                                color: "#000",
                                                                                whiteSpace: "pre",
                                                                            }}>{text}</div>
                                                                        </>
                                                                    ) : (
                                                                        <span style={{ fontSize: 12, color: "#888", width: "100%", textAlign: "center" }}>미리보기 없음</span>
                                                                    )}
                                                                </div>

                                                                {/* 3) 버튼 그룹: 등록/취소, 수정/취소, 초기화(삭제) */}
                                                                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                                                    {superJackpotEditing ? (
                                                                        // 파일을 선택해 편집(등록 or 수정) 중
                                                                        superJackpotRegistered ? (
                                                                            // 기존 이미지가 있었던 경우: 수정/취소
                                                                            <>
                                                                                <button className="superJackpot-btn" onClick={onSubmitSuperJackpotUploadOrUpdate}>
                                                                                    수정
                                                                                </button>
                                                                                <button className="superJackpot-btn" onClick={onClickSuperJackpotCancel}>
                                                                                    취소
                                                                                </button>
                                                                            </>
                                                                        ) : (
                                                                            // 기존 이미지가 없던 경우(최초 등록): 등록/취소
                                                                            <>
                                                                                <button className="superJackpot-btn" onClick={onSubmitSuperJackpotUploadOrUpdate}>
                                                                                    등록
                                                                                </button>
                                                                                <button className="superJackpot-btn" onClick={onClickSuperJackpotCancel}>
                                                                                    취소
                                                                                </button>
                                                                            </>
                                                                        )
                                                                    ) : (
                                                                        // 편집 중이 아닐 때
                                                                        <>
                                                                            {/* 초기화(삭제): 원본이 있을 때만 노출 */}
                                                                            {superJackpotRegistered && (
                                                                                <button className="superJackpot-btn" onClick={onClickSuperJackpotDelete}>
                                                                                    초기화
                                                                                </button>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="superJackpot-input-grid">
                                                        <div className="superJackpot-col-7" style={{ width: "300px" }}>
                                                            <label className="superJackpot-form-label">티켓</label>
                                                            <input
                                                                className="superJackpot-form-control"
                                                                placeholder="티켓 입력"
                                                                value={text}
                                                                onChange={(e) => setText(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="superJackpot-col-2" style={{ width: "80px" }}>
                                                            <label className="superJackpot-form-label">수량</label>
                                                            <input
                                                                className="superJackpot-form-control superJackpot-text-right"
                                                                type="number"
                                                                min={0}
                                                                value={qty}
                                                                onChange={(e) => setQty(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="superJackpot-col-3">
                                                            <button
                                                                className="superJackpot-btn"
                                                                onClick={onSubmitSuperTicketAdd}
                                                                disabled={!isValid}
                                                                title={!isValid ? "회차/티켓/수량을 확인하세요" : "추가"}
                                                            >
                                                                추가
                                                            </button>
                                                        </div>

                                                        <div className="superJackpot-col-3">
                                                            {/* 숨김 파일 입력 */}
                                                            <input
                                                                ref={fileRef}
                                                                type="file"
                                                                accept=".xlsx,.xls,.csv"
                                                                style={{ display: "none" }}
                                                                onChange={onChangeAndUpload}
                                                            />

                                                            {/* 기존 버튼 그대로 사용 */}
                                                            <button
                                                                className="superJackpot-btn"
                                                                style={{ width: "100px" }}
                                                                onClick={openPicker}
                                                                disabled={uploading}
                                                            >
                                                                {uploading ? "업로드 중..." : "엑셀업로드"}
                                                            </button>
                                                        </div>

                                                        <div className="superJackpot-col-3">
                                                            <button
                                                                className="superJackpot-btn"
                                                                onClick={excelSample}
                                                            >
                                                                샘플
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {(superListSelect ?? []).some(item => item.sjm_id == superSelectId && item.is_executable === "Y") && (
                                                        <div className="superJackpot-input-grid">
                                                            <div className="superJackpot-col-3">
                                                                <button className="superJackpot-btn" onClick={onSubmitSuperTicketComplete}>
                                                                    실행
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className={`main-box ${darkname}`}>
                                                <div className={`member-2 ${darkname}`} style={{ marginTop: "50px", width: "460px" }}>
                                                    <div className={`table-head ${darkname}`}>
                                                        <div style={{ width: "5%", minWidth: "80px" }}>No.</div>
                                                        <div style={{ width: "30%", minWidth: "200px" }}>티켓</div>
                                                        <div style={{ width: "5%", minWidth: "80px" }}>수량</div>
                                                        <div style={{ width: "10%", minWidth: "100px" }}></div>
                                                    </div>
                                                    <div className='table-body' style={{ minHeight: "600px" }}>
                                                        {
                                                            spinner
                                                                ?
                                                                <div className='spinner-modal'>
                                                                    <SyncLoader color="#003577" />
                                                                </div>
                                                                :
                                                                superTicketList.length === 0
                                                                    ?
                                                                    <div className='data-nofound'>
                                                                        <img src='/img/img_nofound.png'></img>
                                                                        <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                                                        <p>NO RECORDS FOUND</p>
                                                                    </div>
                                                                    :
                                                                    <>
                                                                        {
                                                                            superTicketList.map(function (a, i) {
                                                                                return (
                                                                                    <SuperJackpotTicketList key={i} item={a} darkname={darkname} setSuperReload={setSuperReload} seq={i + 1} />
                                                                                )
                                                                            })
                                                                        }
                                                                    </>

                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div style={{ width: "100%" }}>
                                            <div className={`main-box ${darkname}`}>
                                                <div className={`member-2 ${darkname}`} style={{ marginTop: "50px", width: "630px" }}>
                                                    <div className={`table-head ${darkname}`}>
                                                        <div style={{ width: "5%", minWidth: "80px" }}>No.</div>
                                                        <div style={{ width: "20%", minWidth: "200px" }}>회차</div>
                                                        <div style={{ width: "5%", minWidth: "80px" }}>수량</div>
                                                        <div style={{ width: "5%", minWidth: "80px" }}>당첨자 수</div>
                                                        <div style={{ width: "5%", minWidth: "80px" }}>당첨률</div>
                                                        <div style={{ width: "10%", minWidth: "100px" }}></div>
                                                    </div>
                                                    <div className='table-body' style={{ minHeight: "600px" }}>
                                                        {
                                                            spinner
                                                                ?
                                                                <div className='spinner-modal'>
                                                                    <SyncLoader color="#003577" />
                                                                </div>
                                                                :
                                                                superHistoryList.length === 0
                                                                    ?
                                                                    <div className='data-nofound'>
                                                                        <img src='/img/img_nofound.png'></img>
                                                                        <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                                                        <p>NO RECORDS FOUND</p>
                                                                    </div>
                                                                    :
                                                                    <>
                                                                        {
                                                                            superHistoryList.map(function (a, i) {
                                                                                return (
                                                                                    <SuperJackpotHistoryList key={i} item={a} darkname={darkname} setSuperReload={setSuperReload} />
                                                                                )
                                                                            })
                                                                        }
                                                                    </>

                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                }
            </div >
        </div >
    );
}




function MemberItem({ item, seq, darkname, dark, handleJackpotInputChange, budgetAmount, userCount }) {
    const [inputValue, setInputValue] = useState(item.value); // 초기값 설정

    useEffect(() => {
        setInputValue(item.value)
    }, [item])

    if (item.name === "jackpot_default_ratio") {
        jackpotEstA = item.value;
    }

    const onChangeInputValue = (e) => {
        const { value } = e.target;
        const onlyNumber = value
            .replace(/[^0-9.]/g, "")
            .replace(/(\..*?)\./g, "$1")
            .replace(/^\./, "");
        setInputValue(onlyNumber);
        handleJackpotInputChange(item.id, onlyNumber); // 상위 컴포넌트로 값 전달
    };

    return (
        <div className={`table-body-tr ${darkname}`}>
            <div className="td" style={{ width: "1%", minWidth: "50px" }}>{seq}</div>
            <div className="td" style={{ width: "15%", minWidth: "150px" }}>
                <input
                    value={inputValue}
                    onChange={onChangeInputValue}
                    placeholder={item.value}
                    style={{ width: "95%", minWidth: "140px", padding: "3px" }}
                />
            </div>
            <div className="left td" style={{ width: "20%", minWidth: "250px" }}>
                {item.format}
                &emsp;&emsp;&emsp;<div style={{ color: "red" }}>
                    {item.name === "jackpot_default_ratio" ? "잭팟 평균: " + changeNum(budgetAmount / userCount * jackpotEstA).split('.')[0] : ""}
                    {item.name === "jackpot_up_ratio" ? "잭팟 최대: " + changeNum(budgetAmount / userCount * jackpotEstA * item.value).split('.')[0] : ""}
                    {item.name === "jackpot_down_ratio" ? "잭팟 최소: " + changeNum(budgetAmount / userCount * jackpotEstA * item.value).split('.')[0] : ""}
                </div>
            </div>
            <div className="left td" style={{ width: "49%", minWidth: "350px" }}>{item.desc}</div>
        </div>
    );
}

function DiaModal({ dark, darkname, setDiaModal, clickId, setReload }) {
    const [userDayData, setUserDayData] = useState([]);
    const [originalData, setOriginalData] = useState([]); // 원본 데이터를 저장
    const [isEditing, setIsEditing] = useState(false); // 수정 모드 여부

    useEffect(() => {
        UpgradeData();
    }, []);

    const UpgradeData = async () => {
        await axios
            .get(process.env.REACT_APP_API + "/api/jackpot/user", {
                params: {
                    userId: clickId.user_id,
                    bdgId: clickId.bdg_id,
                },
            })
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    const parsedData = tmp?.data?.jackpot.map(item => {
                        const { start, end } = parseTimezone(item.timezone);
                        return { ...item, start, end };
                    }) ?? [];
                    setUserDayData(parsedData);
                    setOriginalData(parsedData); // 원본 데이터 저장
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleInputChange = (index, field, value) => {
        const updatedData = [...userDayData];
        updatedData[index][field] = value;
        setUserDayData(updatedData);
    };

    const onSubmitUpdateGold = async () => {
        const formattedData = userDayData.map((item) => ({
            jackpotId: item.id,
            timezone: item.start.padEnd(4, '0') + item.end.padEnd(4, '0'),
            gold: item.gold,
            state: item.state,
        }));

        await axios.post(process.env.REACT_APP_API + "/api/jackpot/user-update", {
            jackpot: formattedData
        })
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    setDiaModal(false);
                    setReload((e) => !e);
                    setIsEditing(false);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleCancel = () => {
        setUserDayData(originalData); // 원본 데이터 보관
        setIsEditing(false); // 수정 모드 종료
    };

    const parseTimezone = (timezone) => {
        if (timezone.length === 4) {
            return {
                start: timezone.substring(0, 2) + "00",
                end: timezone.substring(2, 4) + "00",
            };
        } else if (timezone.length === 8) {
            return {
                start: timezone.substring(0, 4),
                end: timezone.substring(4, 8),
            };
        } else {
            return {
                start: "0000",
                end: "0000"
            };
        }
    };

    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: "660px" }}>
                    <div className="modal-1-header">유저 아이디: {clickId.user_id}</div>

                    <div className={`member-2 ${darkname}`} style={{ width: "600px" }}>
                        <div className={`table-head ${darkname}`}>
                            <div style={{ width: "20%", minWidth: "50px" }}>버짓 아이디</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>시작시간</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>종료시간</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>버짓 금액</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>당첨 상태</div>
                        </div>
                        <div className="table-body" style={{ minHeight: "600px" }}>
                            {userDayData.length === 0 ? (
                                <div className="data-nofound">
                                    <img src="/img/img_nofound.png" alt="No records found" />
                                    <p>NO RECORDS FOUND</p>
                                </div>
                            ) : (
                                <>
                                    {userDayData.map((item, i) => (
                                        <div className={`table-body-tr ${darkname}`} key={i}>
                                            <div className="left td" style={{ width: "20%", minWidth: "50px" }}>
                                                {item.id}
                                            </div>
                                            <div className="right td" style={{ width: "20%", minWidth: "50px" }}>
                                                {isEditing ? (
                                                    <input
                                                        type="text"
                                                        value={item.start}
                                                        onChange={(e) =>
                                                            handleInputChange(
                                                                i,
                                                                "start",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    `${item.start.substring(0, 2)}:${item.start.substring(2, 4)}`
                                                )}
                                            </div>
                                            <div className="right td" style={{ width: "20%", minWidth: "50px" }}>
                                                {isEditing ? (
                                                    <input
                                                        type="text"
                                                        value={item.end}
                                                        onChange={(e) =>
                                                            handleInputChange(
                                                                i,
                                                                "end",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    `${item.end.substring(0, 2)}:${item.end.substring(2, 4)}`
                                                )}
                                            </div>
                                            <div className="right td" style={{ width: "20%", minWidth: "50px" }}>
                                                {isEditing ? (
                                                    <input
                                                        type="number"
                                                        value={item.gold}
                                                        onChange={(e) => handleInputChange(i, "gold", e.target.value)}
                                                    />
                                                ) : (
                                                    item.gold
                                                )}
                                            </div>
                                            <div className="right td" style={{ width: "20%", minWidth: "50px" }}>
                                                {isEditing ? (
                                                    <select
                                                        value={item.state}
                                                        onChange={(e) => handleInputChange(i, "state", e.target.value)}
                                                    >
                                                        <option value="Y">Y</option>
                                                        <option value="N">N</option>
                                                    </select>
                                                ) : (
                                                    item.state
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>

                    <div className="modal-btn-box">
                        {isEditing ? (
                            <>
                                <div className={`modal-btn ${darkname}`} onClick={handleCancel}>
                                    취소
                                </div>
                                <div className={`modal-btn ${darkname}`} onClick={onSubmitUpdateGold}>
                                    등록
                                </div>
                            </>
                        ) : (
                            <>
                                <div className={`modal-btn ${darkname}`} onClick={() => setDiaModal(false)}>
                                    취소
                                </div>
                                <div className={`modal-btn ${darkname}`} onClick={() => setIsEditing(true)}>
                                    수정
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

function BudgetUpdate({ darkname, setBudgetModal, clickId, setReload }) {
    const [input, setInput] = useState("")
    const onChangeInput = (e) => {
        const { value } = e.target
        const onlyNumber = value.replace(/[^0-9]/g, "")
        setInput(onlyNumber)
    }

    const onSubmitUpdateGold = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/budget', {
            budgetId: clickId.id,
            budgetAmount: input
        }, {
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setBudgetModal(false)
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    return (
        <div className='modal'>
            <div className='modal-box'>
                <div className='modal-1' style={{ width: "400px" }}>
                    <div className='modal-1-header'>버짓 수정</div>

                    <div style={{ marginBottom: "30px" }}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>기존 버짓</div>
                            <div className={`password-1 ${darkname}`}>
                                <div>{changeNum(clickId.total_budget)}</div>
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>사용된 버짓</div>
                            <div className={`password-1 ${darkname}`}>
                                <div>{changeNum(clickId.spent_amount)}</div>
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>버짓 총량 변경</div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={input} onChange={onChangeInput} placeholder='버짓 총량 변경' />
                            </div>
                        </div>
                    </div>
                    <div className='modal-btn-box'>
                        <div className={`modal-btn ${darkname}`} onClick={() => { onSubmitUpdateGold() }}>확인</div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setBudgetModal(false)}>취소</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function JackpotImgList({ item, darkname, dark, setReload, setMessage, newBudget }) {
    const [jackpotImgModal, setJackpotImgModal] = useState(false);
    const [clickId, setClickId] = useState([]);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 }); // 이미지 크기 상태

    const onClickData = () => {
        setClickId(item);
        setJackpotImgModal(true);
    };

    const onSubmitDelete = async () => {
        await axios
            .post(
                process.env.REACT_APP_API + "/api/setting/jackpot/img-delete",
                { imgId: item.id },
                {
                    // headers: { 'Content-Type': 'multipart/form-data' },
                }
            )
            .then((response) => {
                let tmp = response?.data;
                if (tmp?.code < 2000) {
                    setReload((e) => !e);
                } else {
                    // setMessage({ msg: "등록에 실패했습니다." })
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleImageLoad = (e) => {
        const img = e.target;
        setDimensions({
            width: img.naturalWidth, // 원본 가로 크기
            height: img.naturalHeight, // 원본 세로 크기
        });
    };

    return (
        <>
            <div className={`table-body-tr ${darkname}`} style={{ height: dimensions.height }}>
                {jackpotImgModal && (
                    <JackpotImgModal
                        darkname={darkname}
                        setJackpotImgModal={setJackpotImgModal}
                        clickId={clickId}
                        setReload={setReload}
                    />
                )}
                <div className="td" style={{ width: "15%", minWidth: "150px", fontSize: "14px" }}>
                    {item?.gold_rate ?? ""}~{newBudget?.gold_rate ? newBudget?.gold_rate - 1 : ""}
                </div>
                <div className="td" style={{ width: "50%", minWidth: "200px" }}>
                    <img
                        src={item.url}
                        alt="Jackpot"
                        onLoad={handleImageLoad} // 이미지 로드 이벤트 핸들러
                    />
                </div>
                <div className="td" style={{ width: "10%", minWidth: "200px" }}>{dimensions.width}px</div>
                <div className="td" style={{ width: "10%", minWidth: "200px" }}>{dimensions.height}px</div>
                <div
                    className="td"
                    style={{
                        width: "15%",
                        minWidth: "150px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "15px",
                    }}
                >
                    {item.id === 1 ? (
                        <>
                            <div
                                className="upgrade-btn"
                                onClick={() => onClickData()}
                                style={{ backgroundColor: "#003577", color: "#fff", width: "45px" }}
                            >
                                수정
                            </div>
                            <div
                                className="upgrade-btn"
                                style={{ background: "#fff", color: "#fff", border: "#fff", cursor: "auto", width: "45px" }}
                            >
                            </div>
                        </>
                    ) : (
                        <>
                            <div
                                className="upgrade-btn"
                                onClick={() => onClickData()}
                                style={{ backgroundColor: "#003577", color: "#fff", width: "45px" }}
                            >
                                수정
                            </div>
                            <div className="upgrade-btn" style={{ width: "45px" }} onClick={() => onSubmitDelete()}>
                                삭제
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

function JackpotImgModal({ darkname, setJackpotImgModal, clickId, setReload }) {
    const [formData, setFormData] = useState({
        rate: clickId.gold_rate, // 초기 금액 값
        uploadedFile: null, // 업로드된 파일
    });

    const [imagePreview, setImagePreview] = useState(null); // 미리보기 이미지 상태

    // 파일 선택 핸들러
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({
                ...prev,
                uploadedFile: file,
            }));

            // 미리보기 이미지 설정
            const previewUrl = URL.createObjectURL(file);
            setImagePreview(previewUrl);
        }
    };

    // 입력 값 변경 핸들러
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // 폼 제출 핸들러
    const handleModalSubmit = async () => {
        const formDataToSend = new FormData();
        formDataToSend.append('imgId', clickId.id);
        formDataToSend.append('file', formData.uploadedFile || ""); // 파일이 없으면 빈 문자열
        formDataToSend.append('rate', formData.rate);

        await axios.post(process.env.REACT_APP_API + '/api/setting/jackpot/img-update', formDataToSend, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code === 1000) {
                    setJackpotImgModal(false);
                    setReload((e) => !e); // 데이터 새로고침
                }
            })
            .catch((error) => {
                console.error("파일 업로드 중 오류 발생:", error);
            });
    };

    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: '1000px' }}>
                    <div className="modal-1-header">스킨 이미지 수정</div>

                    <div className="modal-body">
                        <div className="modal-flex" style={{ marginBottom: "50px" }}>
                            <div>
                                <div style={{ height: '50px' }}>기존 이미지</div>
                                <div>
                                    <img
                                        src={clickId.url}
                                        style={{ height: '150px' }}
                                        alt="기존 이미지"
                                    />
                                </div>
                            </div>
                            <div>
                                <div style={{ height: '50px' }}>
                                    <div>변경 이미지</div>
                                    <label
                                        htmlFor="modalFile"
                                        className="form-control file_form"
                                        style={{ display: 'block', cursor: 'pointer' }}
                                    >
                                        {formData.uploadedFile
                                            ? formData.uploadedFile.name
                                            : '파일선택'}
                                    </label>
                                    <input
                                        className="file-input"
                                        type="file"
                                        id="modalFile"
                                        name="modalFile"
                                        style={{ display: 'none' }}
                                        accept="image/*"
                                        onChange={handleFileChange}
                                    />
                                </div>
                                <div>
                                    {imagePreview && (
                                        <img
                                            src={imagePreview}
                                            alt="변경 이미지 미리보기"
                                            className="multipreview"
                                            style={{ height: '150px' }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        {
                            clickId.id === 1
                                ?
                                <div
                                    className="modal-body-flex"
                                    style={{ width: '600px', margin: '0 auto', marginBottom: '15px' }}
                                >
                                    <div style={{ width: '150px' }}>잭팟 최소 금액</div>
                                    <div style={{ width: '200px' }}>
                                        <input
                                            type="text"
                                            name="rate"
                                            value={formData.rate}
                                            disabled
                                            placeholder="잭팟 최소 금액을 입력하세요"
                                            style={{ width: '100%', color: "gray" }}
                                        />
                                    </div>
                                </div>
                                :
                                <div
                                    className="modal-body-flex"
                                    style={{ width: '600px', margin: '0 auto', marginBottom: '15px' }}
                                >
                                    <div style={{ width: '150px' }}>잭팟 최소 금액</div>
                                    <div style={{ width: '200px' }}>
                                        <input
                                            type="text"
                                            name="rate"
                                            value={formData.rate}
                                            onChange={handleInputChange}
                                            placeholder="잭팟 최소 금액을 입력하세요"
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                </div>
                        }
                    </div>

                    <div className="modal-btn-box">
                        <div
                            className={`modal-btn ${darkname}`}
                            onClick={handleModalSubmit}
                        >
                            확인
                        </div>
                        <div
                            className={`modal-btn ${darkname}`}
                            onClick={() => setJackpotImgModal(false)}
                        >
                            취소
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function SuperJackpotList({ item, darkname, setSuperReload }) {
    // 편집 모드/값
    const [isEditing, setIsEditing] = useState(false);
    const [editWinRate, setEditWinRate] = useState(
        item?.sjm_win_rate != null ? String(item.sjm_win_rate) : ""
    );
    const [editUnitCount, setEditUnitCount] = useState(
        item?.sjm_unit_count != null ? String(item.sjm_unit_count) : ""
    );
    const [isSubmitting, setIsSubmitting] = useState(false);

    // row 데이터가 바뀌면 편집값 동기화 (편집 중이 아닐 때만)
    useEffect(() => {
        if (!isEditing) {
            setEditWinRate(item?.sjm_win_rate != null ? String(item.sjm_win_rate) : "");
            setEditUnitCount(item?.sjm_unit_count != null ? String(item.sjm_unit_count) : "");
        }
    }, [item, isEditing]);

    // 삭제
    const onSubmitJackpotListDelete = async () => {
        if (!window.confirm("삭제하시겠습니까?")) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/super-jackpot/delete",
                { sjmId: item.sjm_id }
            );
            const tmp = response.data;
            console.log(tmp);
            if (tmp?.code === 1000) setSuperReload((e) => !e);
        } catch (error) {
            console.log(error);
        }
    };

    // 값 검증
    const validate = () => {
        const wr = parseFloat(editWinRate);
        if (!Number.isFinite(wr) || wr < 0 || wr > 100) {
            alert("당첨확률은 0~100 사이의 숫자여야 합니다.");
            return false;
        }
        const uc = parseInt(editUnitCount, 10);
        if (!Number.isInteger(uc) || uc < 0) {
            alert("최대중복당첨은 0 이상의 정수여야 합니다.");
            return false;
        }
        return true;
    };

    // 수정(저장)
    const onSubmitJackpotListUpdate = async () => {
        if (!validate()) return;
        if (!window.confirm("수정하시겠습니까?")) return;

        try {
            setIsSubmitting(true);
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/super-jackpot/update",
                {
                    sjmId: item.sjm_id,
                    sjmName: item.sjm_name,
                    sjmStartTime: item.sjm_start_time,
                    sjmEndTime: item.sjm_end_time,
                    sjmWinRate: String(parseFloat(editWinRate)),     // 변경값만 업데이트
                    sjmUnitCount: String(parseInt(editUnitCount, 10)),
                }
            );
            const tmp = response.data;
            console.log(tmp);
            if (tmp?.code === 1000) {
                setIsEditing(false);
                setSuperReload((e) => !e);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    // 버튼 동작: 보기모드 → 편집모드, 편집모드 → 저장
    const handleEditClick = () => {
        if (isEditing) {
            onSubmitJackpotListUpdate();
        } else {
            setIsEditing(true);
        }
    };

    // 취소: 값 되돌리고 편집모드 종료
    const handleCancel = () => {
        setEditWinRate(item?.sjm_win_rate != null ? String(item.sjm_win_rate) : "");
        setEditUnitCount(item?.sjm_unit_count != null ? String(item.sjm_unit_count) : "");
        setIsEditing(false);
    };

    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className="td" style={{ width: "5%", minWidth: "50px" }}>{item.sjm_id}</div>
                <div className="td" style={{ width: "20%", minWidth: "150px" }}>{item.sjm_name}</div>
                <div className="td" style={{ width: "20%", minWidth: "150px" }}>{item.sjm_start_time}</div>
                <div className="td" style={{ width: "20%", minWidth: "150px" }}>{item.sjm_end_time}</div>

                {/* 당첨확률 */}
                <div className="td" style={{ width: "5%", minWidth: "120px" }}>
                    {!isEditing ? (
                        item.sjm_win_rate
                    ) : (
                        <input
                            className="superJackpot-form-control superJackpot-text-right"
                            type="number"
                            min={0}
                            max={100}
                            step="0.01"
                            value={editWinRate}
                            onChange={(e) => setEditWinRate(e.target.value)}
                            style={{ width: "100%" }}
                        />
                    )}
                </div>

                {/* 최대중복당첨 */}
                <div className="td" style={{ width: "10%", minWidth: "120px" }}>
                    {!isEditing ? (
                        item.sjm_unit_count
                    ) : (
                        <input
                            className="superJackpot-form-control superJackpot-text-right"
                            type="number"
                            min={0}
                            step="1"
                            value={editUnitCount}
                            onChange={(e) => setEditUnitCount(e.target.value)}
                            style={{ width: "100%" }}
                        />
                    )}
                </div>

                {/* 버튼들 */}
                <div className="td" style={{ width: "20%", minWidth: "150px" }}>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "center" }}>
                        {!isEditing ? (
                            <>
                                <div className="upgrade-btn" onClick={handleEditClick}>수정</div>
                                <div className="upgrade-btn" onClick={onSubmitJackpotListDelete}>삭제</div>
                            </>
                        ) : (
                            <>
                                <div className="upgrade-btn" onClick={handleEditClick}>
                                    {isSubmitting ? "저장중..." : "수정"}
                                </div>
                                <div className="upgrade-btn" onClick={handleCancel}>취소</div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

function SuperJackpotTicketList({ item, darkname, setSuperReload, seq }) {

    const onSubmitJackpotTicketListDelete = async () => {
        if (window.confirm("삭제하시겠습니까?")) {
            await axios.post(process.env.REACT_APP_API + '/api/super-jackpot/ticket/delete', {
                sjmId: item.sjm_id,
                sjName: item.sj_name,
            }, {
                // headers: { Authorization: `Bearer ${JWT}` }
            }).then((response) => {
                let tmp = response.data
                console.log(tmp)
                if (tmp?.code == 1000) {
                    setSuperReload(e => !e)
                }
            }).catch((error) => {
                console.log(error)
            })
        };
    }
    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className="td" style={{ width: "5%", minWidth: "80px" }}>{seq}</div>
                <div className="td left" style={{ width: "30%", minWidth: "200px" }}>{item.sj_name}</div>
                <div className="td" style={{ width: "5%", minWidth: "80px" }}>{item.cnt}</div>
                <div className="td" style={{ width: "10%", minWidth: "100px" }}>
                    <div className="upgrade-btn" onClick={() => { onSubmitJackpotTicketListDelete() }}>삭제</div>
                </div>
            </div>
        </>
    );
}

function SuperJackpotHistoryList({ item, darkname, setSuperReload }) {

    const onSubmitJackpotHistoryExel = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/super-jackpot/excel', {
            params: {
                sjmId: item.sjm_id,
            }
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                excelData(tmp?.data?.excelData ?? [])
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    const onSubmitJackpotHistoryEnd = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/super-jackpot/end', {
            sjmId: item.sjm_id,
        }, {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                setSuperReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    const excelData = (exData) => {
        let arr = [];

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]

                arr.push({
                    "no": i + 1,
                    "회차": item?.sjm_name ?? "",
                    "티켓": t?.sj_name ?? "",
                    "당첨자ID": t?.sj_winner_id ?? "",
                    "당첨자이름": t?.user_name ?? "",
                    "당첨시간": t?.sj_win_date ?? "",
                })
            }
        }
        Excel(arr, item.sjm_name)
    };

    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className="td" style={{ width: "5%", minWidth: "80px" }}>{item.sjm_id}</div>
                <div className="td" style={{ width: "20%", minWidth: "200px" }}>{item.sjm_name}</div>
                <div className="td" style={{ width: "5%", minWidth: "80px" }}>{item.total_count}</div>
                <div className="td" style={{ width: "5%", minWidth: "80px" }}>{item.winner_count}</div>
                <div className="td" style={{ width: "5%", minWidth: "80px" }}>{Number(item.winner_count)
                    ? `${Math.floor((Number(item.winner_count) * 100) / Number(item.total_count))}%`
                    : "0%"}
                </div>
                <div className="td" style={{ width: "10%", minWidth: "100px" }}>
                    {
                        item.sjm_status == "E"
                            ?
                            <div className="upgrade-btn" onClick={() => { onSubmitJackpotHistoryExel() }}>엑셀</div>
                            :
                            <div className="upgrade-btn" onClick={() => { onSubmitJackpotHistoryEnd() }}>종료</div>
                    }
                </div>
            </div>
        </>
    );
}

const Excel = (excelData, sjm_name) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `잭팟내역_${sjm_name}`;

    const headerRow = [
        "no", "회차", "티켓", "당첨자ID", "당첨자이름", "당첨시간",
    ];

    const bodyRows = excelData.map((data) => ([
        data.no, data.회차, data.티켓, data.당첨자ID, data.당첨자이름, data.당첨시간
    ]));

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = Array(headerRow.length).fill({ wpx: 100 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};


const ExcelSample = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `슈퍼잭팟 엑셀업로드 샘플`;

    const headerRow = [
        "name", "quantity"
    ];

    const bodyRows = excelData.map((data) => ([
        data.name, data.quantity
    ]));

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = Array(headerRow.length).fill({ wpx: 100 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default JackpotSetting;